// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2oHG0","title":"BackImages_title__2RQgH","images":"BackImages_images__BT1cC"};